import * as S from './Submit.styles'

interface Props {
  disabled: boolean,
  text: string,
  width?: string
  height?: string
  className?: string
  onClick?: Function
  testId?: string
}

export default ({
  disabled, text, width, height, className, onClick = () => {}, testId,
}: Props) => (
  <S.Button
    width={width}
    height={height}
    type='submit'
    value={text}
    onClick={() => onClick()}
    disabled={disabled}
    className={className}
    data-testid={testId || 'submit-button-test-id'}
  />
)
